import { action } from 'satcheljs';

/**
 * Action which sets the current isToastShown in the state based on the input
 * @param isToastShown the new value for isShown
 */
export default action('changeIsToastShown', function changeIsToastShown(isToastShown: boolean) {
    return { isToastShown };
});
